import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('FIREWORKS', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  const t = elapsed / 16.6;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const speed = 4 + rnd * 4;
    const x = e.pos.x + Math.cos(angle) * speed * t;
    const y = e.pos.y + Math.sin(angle) * speed * t + 0.5 * 0.1 * t * t;

    ctx.fillStyle = determineColor(i, particles);
    ctx.globalAlpha = 1 - progress;
    ctx.beginPath(); ctx.arc(x, y, 2, 0, Math.PI * 2); ctx.fill();
  }
});
